export default __webpack_public_path__ + "static/media/icomoon.004016ba.ttf";